import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes} from 'maestro-ng';
import { PessoaDocumentoService } from '../../pessoa-documento/pessoa-documento.service';
import { PessoaEnderecoService } from '../../pessoa-endereco/pessoa-endereco.service';
import { PessoaGenitorService } from '../../pessoa-genitor/pessoa-genitor.service';
import { PessoaOutroNomeService } from '../../pessoa-outro-nome/pessoa-outro-nome.service';
import { PessoaRelacionamentoService } from '../../pessoa-relacionamento/pessoa-relacionamento.service';
import { Pessoa } from '../pessoa.model';
import { PessoaService } from '../pessoa.service';
import {PessoaTelefoneComponent} from '../../pessoa-telefone/pessoa-telefone.component';
import {PessoaEnderecoEletronicoComponent} from '../../pessoa-endereco-eletronico/pessoa-endereco-eletronico.component';
import {PessoaDocumento} from '../../pessoa-documento/pessoa-documento.model';
import {DataSourceRouted} from '../../util/data-source-routed';
import {PessoaEndereco} from '../../pessoa-endereco/pessoa-endereco.model';
import {PessoaOutroNome} from '../../pessoa-outro-nome/pessoa-outra-nome.model';
import {PessoaRelacionamento} from '../../pessoa-relacionamento/pessoa-relacionamento.model';
import {PessoaGenitor} from '../../pessoa-genitor/pessoa-genitor.model';
import {SelectItem} from 'primeng/api';
import {SelectItemService} from '../../services/select-item.service';

@Component({
  selector: 'app-pessoa-visualizacao',
  templateUrl: './pessoa-visualizacao.component.html',
  styleUrls: ['./pessoa-visualizacao.component.css']
})
export class PessoaVisualizacaoComponent implements OnInit  {

  public static TAB_DOCUMENTOS = 0;
  public static TAB_ENDERECOS = 1;
  public static TAB_OUTROS_NOMES = 2;
  public static TAB_RELACIONAMENTOS = 3;
  public static TAB_TELEFONES = 4;
  public static TAB_ENDERECOS_ELETRONICOS = 5;
  public static TAB_GENITORES = 6;

  public pessoa: Pessoa;

  public dsDocumentos: DataSourceRouted<PessoaDocumento, number>;
  public dsEndereco: DataSourceRouted<PessoaEndereco, number>;
  public dsOutrosNomes: DataSourceRouted<PessoaOutroNome, number>;
  public dsRelacionamentos: DataSourceRouted<PessoaRelacionamento, number>;
  public dsGenitores: DataSourceRouted<PessoaGenitor, number>;

  public pessoaOutroNomeTipoItens: SelectItem[];
  public pessoaRelacionamentosTipoItens: SelectItem[];
  public pessoaDocumentoTipoItens: SelectItem[];

  public tabViewIndex = PessoaVisualizacaoComponent.TAB_DOCUMENTOS;

  @ViewChild(PessoaTelefoneComponent)
  private viewPessoaTelefone: PessoaTelefoneComponent;

  @ViewChild(PessoaEnderecoEletronicoComponent)
  private viewPessoaEnderecoEletronico: PessoaEnderecoEletronicoComponent;

  constructor(
    private route: ActivatedRoute,
    private pessoaService: PessoaService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private pessoaDocumentoService: PessoaDocumentoService,
    private pessoaEnderecoService: PessoaEnderecoService,
    private pessoaOutroNomeService: PessoaOutroNomeService,
    private pessoaRelacionamentoService: PessoaRelacionamentoService,
    private selectItemService: SelectItemService,
    private router: Router,
    private pessoaGenitorService: PessoaGenitorService
  ) {
  }

  ngOnInit(): void {
    this.pessoa = {} as Pessoa;
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.progressoService.modal();
        this.pessoaService.recuperarPorId(+params['id'])
          .then((pessoa) => this.carregarPessoa(pessoa))
          .catch(response => this.mensagemService.addErro('Erro ao carregar a pessoa', response.error));
      }
      else if (params['fonteDados'] && params['origemId']) {
        this.progressoService.modal();
        this.pessoaService.recuperarPorOrigemId(params['fonteDados'], params['origemId'])
          .then(pessoa => this.carregarPessoa(pessoa))
          .catch(response => this.mensagemService.addErro('Erro ao carregar a pessoa', response.error));
      }
    });

    this.pessoaOutroNomeTipoItens = this.selectItemService.getPessoaOutroNomeTipo();
    this.pessoaRelacionamentosTipoItens = this.selectItemService.getPessoaRelacionamentoTipo();
    this.pessoaDocumentoTipoItens = this.selectItemService.getPessoaDocumentoTipo();
  }

  public carregarPessoa(pessoa: Pessoa) {
    this.pessoa = pessoa;
    this.carregarDocumentos();
    this.carregarGenitores();
  }

  public onChangeTabView() {

    switch (this.tabViewIndex) {
      case PessoaVisualizacaoComponent.TAB_DOCUMENTOS:
        break;
      case PessoaVisualizacaoComponent.TAB_ENDERECOS:
        if (!this.pessoa.enderecos) { this.carregarEnderecos(); }
        break;
      case PessoaVisualizacaoComponent.TAB_OUTROS_NOMES:
        if (!this.pessoa.outrosNomes) { this.carregarOutrosNomes(); }
        break;
      case PessoaVisualizacaoComponent.TAB_RELACIONAMENTOS:
        if (!this.pessoa.relacionamentos) { this.carregarRelacionamentos(); }
        break;
      case PessoaVisualizacaoComponent.TAB_TELEFONES:
        this.viewPessoaTelefone.carregarTelefones();
        break;
      case PessoaVisualizacaoComponent.TAB_ENDERECOS_ELETRONICOS:
        this.viewPessoaEnderecoEletronico.carregarEnderecosEletronico();
        break;
      case PessoaVisualizacaoComponent.TAB_GENITORES:
        if (!this.pessoa.genitores) { this.carregarGenitores(); }
        break;
    }
  }

  public carregarDocumentos(): void {
    this.progressoService.modeless();
    if (this.dsDocumentos === undefined) {
      this.dsDocumentos = new DataSourceRouted<PessoaDocumento, number>(
        'pessoa-documentos',
        (c) => this.pessoaDocumentoService.recuperarPaginadoPorPessoaId(this.pessoa.id, c),
        this.mensagemService, this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes(
          [
            new Restricao<number>({atributo: 'id', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'origemId', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'tipo', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'numero', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'nome', operador: RestricaoOperador.CONTAINS}),
            new Restricao<string>({atributo: 'emissor', operador: RestricaoOperador.CONTAINS})
          ]
        )
      );
    }
    else {
      this.dsDocumentos.pesquisar();
    }
    this.progressoService.fechar();
  }

  public carregarEnderecos(): void {
    this.progressoService.modeless();
    if (this.dsEndereco === undefined) {
      this.dsEndereco = new DataSourceRouted<PessoaEndereco, number>(
        'pessoa-endereco',
        (c) => this.pessoaEnderecoService.recuperarPaginadoPorPessoaId(this.pessoa.id, c),
        this.mensagemService, this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes(
          [
            new Restricao<number>({atributo: 'id', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'origemId', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'endereco.cep.numero', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'endereco.logradouro', operador: RestricaoOperador.CONTAINS}),
            new Restricao<string>({atributo: 'endereco.localidadeNome', operador: RestricaoOperador.CONTAINS})
          ]
        )
      );
    }
    else {
      this.dsEndereco.pesquisar();
    }
    this.progressoService.fechar();
  }

  public carregarOutrosNomes(): void {
    this.progressoService.modeless();
    if (this.dsOutrosNomes === undefined) {
      this.dsOutrosNomes = new DataSourceRouted<PessoaOutroNome, number>(
        'pessoa-outrosNomes',
        (c) => this.pessoaOutroNomeService.recuperarPaginadoPorPessoaId(this.pessoa.id, c),
        this.mensagemService, this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes(
          [
            new Restricao<number>({atributo: 'id', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'origemId', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'tipo', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'nome', operador: RestricaoOperador.CONTAINS})
          ]
        )
      );
    }
    else {
      this.dsOutrosNomes.pesquisar();
    }
    this.progressoService.fechar();
  }

  public carregarRelacionamentos(): void {
    this.progressoService.modeless();
    if (this.dsRelacionamentos === undefined) {
      this.dsRelacionamentos = new DataSourceRouted<PessoaRelacionamento, number>(
        'pessoa-outrosNomes',
        (c) => this.pessoaRelacionamentoService.recuperarPaginadoPorPessoaId(this.pessoa.id, c),
        this.mensagemService, this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes(
          [
            new Restricao<number>({atributo: 'id', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'origemId', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'tipo', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'relacionada.nome', operador: RestricaoOperador.CONTAINS})
          ]
        )
      );
    }
    else {
      this.dsRelacionamentos.pesquisar();
    }
    this.progressoService.fechar();
  }

  public carregarGenitores(): void {
    this.progressoService.modeless();
    if (this.dsGenitores === undefined) {
      this.dsGenitores = new DataSourceRouted<PessoaGenitor, number>(
        'pessoa-genitores',
        (c) => this.pessoaGenitorService.recuperarPaginadoPorPessoaId(this.pessoa.id, c),
        this.mensagemService, this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes(
          [
            new Restricao<number>({atributo: 'id', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'origemId', operador: RestricaoOperador.EQUALS}),
            new Restricao<string>({atributo: 'nome', operador: RestricaoOperador.CONTAINS})
          ]
        )
      );
    }
    else {
      this.dsGenitores.pesquisar();
    }
    this.progressoService.fechar();
  }

  public catch(titulo: string, mensagem: string): void {
    this.progressoService.fechar();
    this.mensagemService.addErro(titulo, mensagem);
  }
}
